<template>
  <div class="home">
    <div class="contanier">
      <div class="home-top">
        <img class="home-top-icon" :src="litpic" />
        <!-- <div class="scroll-box" v-show="carousel && carousel.length > 0">
          <vue-seamless-scroll
            :data="carousel"
            class="seamless-warp"
            :class-option="classOption"
          >
            <div v-for="(item, index) in carousel" :key="index" class="scroll-item">
              网友 支持了 “{{ item.name }}”
            </div>
          </vue-seamless-scroll>
        </div> -->
      </div>
      <div class="content">
        <vote :list="list" v-show="tabbarIndex == 0" @toQueryVote="getUserList" @logout="logout()"></vote>
        <introduce v-show="tabbarIndex == 1"></introduce>
        <rank-list :ranklist="ranklist" v-show="tabbarIndex == 2"></rank-list>
      </div>
    </div>
    <div class="footer">
      <div class="tabbar">
        <div class="tabbar_item" v-for="(item, index) in tabbarItems" :key="index" 
        @click="tabbarClick(index)"
        :class="tabbarIndex==index?'tabbar_item_selected':'tabbar_item_default'">
          {{item}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { isWeiXin, scene_decode } from '@/utils/tool.js';
import { requestUserList, getUserInfo, getActivityIndex } from '@/http/index';
import { active_url } from "@/http/global";
import Introduce from "../components/IntroduceInfo"; 
import Vote from '../components/vote';
import RankList from '../components/rankList.vue';
// import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: 'home',
  components: { 
    Introduce,
    RankList,
    Vote
    // vueSeamlessScroll
  },
  data() {
    return {
      code: "",
      litpic: "",
      list: [],
      tabbarIndex: 0,
      tabbarItems: ["首页","活动详情","评选结果"],
      ranklist: [],
      carousel: []
    }
  },
  computed:{
    classOption() {
      return {
        step: 0.8, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 30, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1500 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  created(){
    localStorage.removeItem("qingdao_cultural_vote_wixin_code_time")
    localStorage.removeItem("qingdao_cultural_vote_wixin_code")
  },
  activated(){
    console.log('home-activated')
  },
  mounted(){
    if (isWeiXin()) {
      var href = window.location.href;
      if (href.indexOf('?code=') != -1 || href.indexOf('&code=') != -1) {
        var scene_code = "";
        if (scene_decode(href.split('?')[1]).code.indexOf('#') != -1) {
          scene_code = scene_decode(href.split('?')[1]).code.split('#')[0]
        } else {
          scene_code = scene_decode(href.split('?')[1]).code
        }
        if(this.code != scene_code){// 获取到code调起后台登录
          console.log("===>code:" + scene_code);
          localStorage.setItem("qingdao_cultural_vote_wixin_code", scene_code);
          this.code = scene_code;
          this.goToLogin()
          window.history.replaceState(null, null, window.location.href.split('?')[0]+'#/');
        }
      }else {
        if(this.code.length == 0){
          this.wxlogin()  
        }
      }
      this.wxshare()
    }
    this.getIntroduceInfo()
    this.getUserList()
    this.getRankList()
  },
  methods: {
    // 登录获取token
    goToLogin(){
      getUserInfo({ code: this.code }).then(res => {
        console.log("后台登录：===》",res)
        localStorage.setItem('qingdao_cultural_vote_token',res.data.token);
        this.getIntroduceInfo()
      })
    },
    // 获取选手列表
    getUserList(){
      requestUserList({type: 1}).then(res => {
        this.list = res.data
      })
    },
    // 获取活动介绍
    getIntroduceInfo(){
      getActivityIndex({ token: localStorage.getItem('qingdao_cultural_vote_token') }).then(res => {
        this.litpic = res.data.litpic,
        this.carousel = res.data.carousel
      })
    },
    // 获取活动介绍
    getRankList(){
      requestUserList({ type: 2 }).then(res => {
        this.ranklist = res.data
      })
    },
    tabbarClick(index){
      this.tabbarIndex = index;
      if(this.tabbarIndex == 2){
        this.getRankList()
      }
    },
    logout(){
      this.wxlogin()
    },
    /**
     * 微信登录
     */
    wxlogin(){
      var href = window.location.href,
      currentTime = new Date(new Date().toLocaleDateString()).getTime();
      if (href.indexOf('from') != -1 || href.indexOf('isappinstalled') != -1) {
        window.history.replaceState(null, null, window.location.href.split('?')[0]);
      }
      if (isWeiXin()) {
        var wixinCode = localStorage.getItem('qingdao_cultural_vote_wixin_code'),
            codeTime = localStorage.getItem('qingdao_cultural_vote_wixin_code_time');
        if (!wixinCode || codeTime < currentTime) {
          localStorage.setItem("qingdao_cultural_vote_wixin_code_time", codeTime);
          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6b6e452b2af7d629&redirect_uri='+encodeURIComponent(active_url)+'&response_type=code&scope=snsapi_base#wechat_redirect'
        }
      } else {
        this.alertModelMsg('请在微信客户端参与该活动');
      }
    },
    wxshare(){
      this.$axios.get('https://bandaoapi.bandaoapp.com/wxapi/wxConfig', {
        params: {
          url: encodeURIComponent('http://activity.bandaoapp.com/activity/vote-active/index.html')
        }
      })
      .then(res => {
        var msg = res.data;
        console.log("微信分享配置===>",msg)
        if (msg.code != 200) {
          console.log("接口返回非200");
          return;
        }
        wx.config({
          appId: msg.result.appId,
          timestamp: msg.result.timestamp,
          nonceStr: msg.result.noncestr,
          signature: msg.result.signature,
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'hideMenuItems',
            'showMenuItems'
          ]
        });
        wx.ready(function() {
          var shareData = {
            title: "“青岛奥帆海洋文化旅游区”IP形象等你来评选", // 分享标题
            desc: '快来为你心中最喜欢的IP形象投票吧', // 分享描述
            link: 'http://activity.bandaoapp.com/activity/vote-active/index.html', // 分享链接 
            imgUrl: "https://bd-jiaoyu.oss-cn-qingdao.aliyuncs.com/2022/05/10/icon.jpg", // 分享图标 
            success: function(res) {
              console.log("微信分享结果：==>",res)
            }
          }
          wx.updateAppMessageShareData(shareData);
          wx.updateTimelineShareData(shareData);
          wx.onMenuShareAppMessage(shareData);
          wx.onMenuShareTimeline(shareData);
          wx.onMenuShareQQ(shareData);
          wx.onMenuShareWeibo(shareData);
        });
        wx.error(function(res) {
          console.log('微信分享error==>',res)
          // alert(JSON.stringify(res))
        });
      })
      .catch(error => {
        console.log(error);
      });
    }

  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .home {
    background-color: #fff;
    width: 100%;
    height: 100%;
    position: relative;
  }
  .contanier {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    background: linear-gradient(0deg, #2165FF 0%, #7CD9FF 100%);
    height: calc(100% - 56px);
    height: calc(100% - 56px - env(safe-area-inset-bottom));
    height: calc(100% - 56px - constant(safe-area-inset-bottom));
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .content {
    transform: translateY(-95px);
    z-index: 99;
    min-height: 100vh;
    -webkit-overflow-scrolling: touch;
  }
  .home-top{
    position: relative;
  }
  .home-top-icon {
    width: 100%;
    display: block;
  }
  .home-top-zfb{
    width: 22vw;
    height: 5.733333333vw;
    position: absolute;
    top: 4.933333333vw;
    right: 3.2vw;
  }
  .scroll-box {
    height: 30px;
    line-height: 30px;
    overflow: hidden;
    position: absolute;
    left: 10px;
    right: 52%;
    bottom: 110px;
    padding: 0 15px;
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 15px;
  }
  .seamless-warp {
    overflow: hidden;
  }
  .scroll-item {
    padding: 1px;
    height: 30px;
    line-height: 30px;
    color: #fff;
    font-size: 14px;
  }
  .footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f5f5f5;
    border-top: 0.01rem solid #d7d8da;
    z-index: 9999;
    height: 56px;
    height: calc(56px + constant(safe-area-inset-bottom)); // tabBar原高度+安全距离,兼容 iOS < 11.2
    height: calc(56px + env(safe-area-inset-bottom)); // 兼容 iOS >= 11.2
  }
  .tabbar {
    height: 56px;
    position: relative;
    flex-direction: row;
    justify-content: space-between;
    display: flex;
    align-items: center;
  }
  .tabbar_item {
    width: 33.2%;
    height: 100%;
    line-height: 56px;
    color: #fff;
    font-weight: bold;
    font-size: 15px;
    text-align: center;
  }
  .tabbar_item_default {
    background-color: #4D95FC;
  }
  .tabbar_item_selected {
    background-color: #65B5F9;
  }
  @media screen and (min-width: 750px) {
    .home-top-zfb{
      width: 165px;
      height: 43px;
      top: 37px;
      right: 24px;
    }
  }
</style>
